import * as reducer from "./slice";

export { createApiDispatchers } from "./dispatchers";
export default reducer;
